import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import classnames from 'classnames/bind'

import SectionLoader from '../SectionLoader'
import ItemCard from '../ItemCard'
import Slider from "../../../../components/slider/Slider"

import styles from './FacilitiesSection.module.scss'

const cx = classnames.bind(styles)

const FacilitiesSection = function ({
  isLoading,
  data,
  info = {},
  browserSizes,
  className = ''
}) {
  const itemsOrdered = (info?.cards || [])?.sort((a, b) => a?.order - b?.order) ?? []

  return (
    <div className={cx('root', className)}>
      {isLoading ? <SectionLoader className={cx('root', 'loader-root')} /> :
        (<div className={cx('cards')}>
          {browserSizes.lessThan.medium && !!itemsOrdered?.length ? (
            <Slider onlyDots>
              {itemsOrdered.map(item => <ItemCard key={item?.code} item={item}/>)}
            </Slider>
            ) : itemsOrdered.map(item => <ItemCard key={item?.code} item={item} />)
          }
        </div>)
      }
    </div>
  )
}

FacilitiesSection.propTypes = {
  data: PropTypes.any,
  info: PropTypes.object,
  isLoading: PropTypes.bool,
  className: PropTypes.string,
  browserSizes: PropTypes.objectOf(Object).isRequired,
}

const mapStateToProps = ({ browser: browserSizes }) => ({
  browserSizes,
})

export default connect(mapStateToProps)(FacilitiesSection)
